import { defaultStore } from './defaultStore';
import { defineStore } from "pinia";

const useTagsStore = defineStore('tags', defaultStore('tags/'))

export {useTagsStore};
